import { GlobalContextProvider } from '~/Features/Configuration/GlobalContextProvider';
import { mapToLocale } from '~/Partials/Locale/Locale';

export const getContentLanguage = () => GlobalContextProvider.getContentLanguage();

export const getContentLocale = () => mapToLocale(getContentLanguage());
